export default __webpack_public_path__ + "static/media/snaketaur.6ee5455b.png";